import * as React from "react";
import { withRouter } from "react-router-dom";

interface Props {
    tabs: string[];
    locationPath: string;
    children({ currentTab }): any;
}
interface State {
    activeTab: string;
}

class Tabs extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: props.tabs.filter(t => props.location.pathname.includes(t))[0],
        };
    }
    public render() {
        return (
            <>
                <div className="ui tabs montserrat bold">
                    {this.props.tabs.map((tab, index, array) =>
                        [<a key={tab} className={`${this.state.activeTab === tab ? "active" : ""} item`} onClick={this.displayTab.bind(this, tab)}>{tab}</a>,
                        index !== array.length - 1 && <div key={`${tab}-div`} className="vertical-divider">|</div>]
                    )}
                </div>
                {this.props.children({ currentTab: this.state.activeTab })}
            </>
        );
    }

    private displayTab = (tab) => {
        this.setState({ activeTab: tab });
        (this.props as any).history.push({ pathname: `/${this.props.locationPath}${tab}` });
    }
}

export default withRouter(Tabs);


// WEBPACK FOOTER //
// ./src/components/Tabs.tsx